import { type SpellingData } from "app/score/scoreState";

export interface TedWordState {
  isOnIntro: boolean;
  userSpellings: Array<SpellingData>;
  answeredCorrectly: boolean;
  numWrongAnswers: number;
}

export const INITIAL_STATE: TedWordState = {
  isOnIntro: true,
  userSpellings: [],
  answeredCorrectly: false,
  numWrongAnswers: 0,
};

export const TedWordAction = {
  INTRO_CLOSED: "INTRO_CLOSED",
  SUBMITTED_SPELLING: "SUBMITTED_SPELLING",
  ROUND_COMPLETED: "ROUND_COMPLETED",
} as const;

export type TedWordAction =
  | {
      type: typeof TedWordAction.INTRO_CLOSED;
    }
  | {
      type: typeof TedWordAction.SUBMITTED_SPELLING;
      payload: { spelling: SpellingData };
    }
  | {
      type: typeof TedWordAction.ROUND_COMPLETED;
    };

export function tedWordReducer(state: TedWordState, action: TedWordAction) {
  switch (action.type) {
    case TedWordAction.INTRO_CLOSED:
      return {
        ...state,
        isOnIntro: false,
      };
    case TedWordAction.SUBMITTED_SPELLING: {
      const isCorrect =
        action.payload.spelling.userSpelling ===
        action.payload.spelling.correctSpelling;
      return {
        ...state,
        answeredCorrectly: isCorrect,
        numWrongAnswers: state.numWrongAnswers + (isCorrect ? 0 : 1),
        userSpellings: [...state.userSpellings, action.payload.spelling],
      };
    }
    case TedWordAction.ROUND_COMPLETED:
      return INITIAL_STATE;

    default:
      return state;
  }
}
